import type { FC, ReactNode } from 'react'

import PageIntro from '@/components/generals/page-intro'

interface PageHeroProps {
    eyebrow: string
    title: string
    description: string
    children?: ReactNode
}

/** The opening band of an inner page: warm paper, a faint halftone glow and the page intro. */
const PageHero: FC<PageHeroProps> = ({ eyebrow, title, description, children }): ReactNode => {
    return (
        <section aria-label={title} data-header-theme='light' className='relative isolate overflow-hidden border-b border-dashed border-line bg-paper'>
            <div aria-hidden='true' className='intro-fade pointer-events-none absolute inset-x-0 top-0 -z-10 h-[36rem] bg-[radial-gradient(55%_65%_at_80%_0%,rgb(124_147_166/0.14),transparent_70%),radial-gradient(45%_55%_at_10%_10%,rgb(196_103_63/0.07),transparent_72%)]' />

            <div className='container-page pb-16 pt-32 sm:pb-24 sm:pt-44'>
                <PageIntro eyebrow={eyebrow} title={title} description={description}>
                    {children}
                </PageIntro>
            </div>
        </section>
    )
}

export default PageHero
